import { acceptableFileFormats } from 'constants/global.constants';
import {
	IPaginationParams,
	IPaginationDefaults,
	DEFAULT_PAGE_SIZE,
	DEFAULT_SORT_BY,
	DEFAULT_SORT_ORDER,
} from 'constants/pagination.constants';
import _ from 'lodash';
import { store } from 'state/store';
import { isValid, format } from 'date-fns';

export type { IPaginationParams, IPaginationDefaults };

export const setErrorMessage = (setMessage: any, error: any) => {
	// Determine the error code with proper fallback:
	// 1. Use errorNumber if it exists
	// 2. Otherwise use statusCode if it exists
	// 3. Fallback to 500 (generic server error)
	const errorCode = error.errorNumber || error.statusCode || 500;
	const errorText = `servers.errors.${errorCode}`;

	store.dispatch(
		setMessage({
			exist: true,
			text: errorText,
		})
	);
};

export const validateFileExtensions = (fileName: string) => {
	const fileExtensions = acceptableFileFormats.split(',');
	const fileType = '.' + fileName.split('.')[1];

	return fileExtensions.includes(fileType);
};

export const isHebrewWord = (term: string) => /[\u0590-\u05FF]/.test(term);

export const getCompanyNameByLanguage = (company: any) => {
	return localStorage.getItem('language') === 'en'
		? company?.english_name || company?.englishName
		: company?.hebrew_name || company?.hebrewName;
};

export const companyIsNotActive = (company: any): boolean => {
	return Boolean(_.has(company, 'closedByBoUser')) && Boolean(_.get(company, 'closedByBoUser'));
};

export const formatValidDate = (value: any, timing: string): any => {
	return value !== null && isValid(new Date(value)) ? format(new Date(value), timing) : value;
};

export const buildPaginationQueryParams = (params?: IPaginationParams, defaults?: IPaginationDefaults) => ({
	offset: params?.offset ?? 0,
	limit: params?.limit || defaults?.limit || DEFAULT_PAGE_SIZE,
	sortBy: params?.sortBy || defaults?.sortBy || DEFAULT_SORT_BY,
	sortOrder: params?.sortOrder || DEFAULT_SORT_ORDER,
	filters: params?.filters ? JSON.stringify(params.filters) : undefined,
});
